import Api from './axios'

const dataCollectionService = {
    async getDatasetDataCollections(datasetId) {
        return await Api.get(`/datacollections/?dataset_id=${datasetId}`)
    }
}

export default dataCollectionService;
